import ScratchPlayer from './ScratchPlayer.vue'


function install(Vue, jsUrl) {
    if (install.installed) return;
    install.installed = true;

    ScratchPlayer.setScriptUrl(jsUrl);

    Vue.component(ScratchPlayer.name, ScratchPlayer)
}

const VueScratchPlayer = {
    install: install,
    ScratchPlayer
};


export default VueScratchPlayer